module.exports = __webpack_public_path__ + "img/4.3ed0488.png";